import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dumbbell, Flame } from 'lucide-react';

import { MUSCLE_ICONS, EQUIPMENT_ICONS } from '../../utils/exerciseIcons';

import '../../styles/pages/treinos.css';

// Pieces the list, the open workout, the editor and the library share

/** The exercise's art on its light tile; a dumbbell stands in when there's none or it fails to load */
export const ExerciseArt = ({ src, className = '' }) => {
  const [failed, setFailed] = useState(false);
  return (
    <span className={`mt-tr-art ${className}`}>
      {src && !failed ? (
        <img src={src} alt="" loading="lazy" onError={() => setFailed(true)} />
      ) : (
        <Dumbbell className="mt-tr-art__none" aria-hidden="true" />
      )}
    </span>
  );
};

/** "Quadríceps · Barra", each with its pictogram (the ones the AI builder shows) */
export const ExerciseWhat = ({ muscle, equipment, className = '' }) => {
  const { t } = useTranslation();
  const parts = [
    muscle && { key: 'muscle', icon: MUSCLE_ICONS[muscle], label: t(`exerciseFilters.muscleGroups.${muscle}`) },
    equipment && { key: 'equipment', icon: EQUIPMENT_ICONS[equipment], label: t(`exerciseFilters.equipmentCategories.${equipment}`) },
  ].filter(Boolean);
  if (!parts.length) return null;
  return (
    <span className={`mt-tr-what ${className}`}>
      {parts.map(({ key, icon, label }, index) => (
        <span key={key} className="mt-tr-what__part">
          {index > 0 && (
            <span className="mt-tr-what__dot" aria-hidden="true">
              ·
            </span>
          )}
          {icon && <img className="mt-tr-what__icon" src={icon} alt="" />}
          <span className="mt-tr-what__label">{label}</span>
        </span>
      ))}
    </span>
  );
};

export const WarmupTag = () => {
  const { t } = useTranslation();
  return (
    <span className="mt-tr-warm">
      <Flame aria-hidden="true" />
      {t('components.ExerciseCard.markAsWarmup')}
    </span>
  );
};
